/**
 * 作者：张小彤
 * 时间：2016/12/12
 * 描述：尾部文件
 */
import React, {Component} from 'react';

import './footer.scss';

export default class Footer extends Component{
    render(){
        return(
            <div className="footerbox">
                <div className="wd1000 footer c">
                    <div className="l footlogo"></div>
                    <div className="r footr pr">
                        <div className="c footnav">
                            <a href="http://www.linekong.com/about?type=introduce" target="_blank">蓝港简介</a>
                            <span> | </span>
                            <a href="http://www.linekong.com/games" target="_blank">旗下游戏</a>
                            <span> | </span>
                            <a href="http://www.linekong.com/join" target="_blank">招贤纳才</a>
                            <span> | </span>
                            <a href="http://www.linekong.com/investor/aboutUs.html" target="_blank">联系我们</a>
                            <span> | </span>
                            <a href="http://www.linekong.com/article-239-1.shtml" target="_blank">法律声明</a>
                            <span> | </span>
                            <a href="javascript:void(0);">设为首页</a>
                            <span> | </span>
                            <a href="javascript:void(0);" >收藏本站</a>
                        </div>
                        <p className="enl">Copyright © 2007-2014 linekong.com, All Rights Reserved</p>
                        <p>蓝港互动有限公司 京网文【2010】0361-001号 京ICP证070501号 京公安网备110105002132 11010502025330</p>
                    </div>
                </div>
            </div>
        )
    }
}


// WEBPACK FOOTER //
// ./D:/front-end-svn/webpack/src/project/sdk/components/footer/footer.jsx